import React from 'react'

import {
  Empty,
  Table,
} from 'antd'

import { responsiveModalWidth } from '../../util/guideline'
import { buildSearchFilterProps } from '../tables/utils'

interface CsvContentRow {
  [key: string]: any
}

const buildFilter = (filters: string[], dataIndex: string) =>
  filters.includes(dataIndex) ? buildSearchFilterProps({ dataIndex }) : {}

const buildColumns = (csvHeadersColumns: CsvContentRow, filters: string[]) =>
  Object.keys(csvHeadersColumns).map((column: string) => ({
    title: column,
    dataIndex: column,
    ...buildFilter(filters, column),
  }))

interface Props {
  data: CsvContentRow[]
  filters: string[]
  rowKey: string
}

export const CsvContent = ({ data, rowKey = 'id', filters = [] }: Props) => {
  if (!data.length) {
    return <Empty />
  }

  const [csvHeadersColumns] = data

  return (
    <Table
      columns={buildColumns(csvHeadersColumns, filters)}
      dataSource={data}
      rowKey={rowKey}
      scroll={{ x: responsiveModalWidth }}
      size="small"
    />
  )
}
